<template>
    <div>
        <!-- <a-input-search style="margin-bottom: 8px" v-model="searchMember" placeholder="Search" @search="onSearchMember" /> -->
        <a-tree
            v-model="checkedKeys"
            checkable
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            :selected-keys="selectedKeys"
            :tree-data="treeData"
            @expand="onExpand"
            @select="onSelect"
        />
    </div> 
    
  </template>
  <script>
  export default {
    props:{
        checkedKeysList:{
            type: Array,
        },
      
    },
    data() {
        return {
            selectedKeys:[],
            expandedKeys:[],
            autoExpandParent: true,
            treeData:[],
            members:[],
            checkedKeys: this.checkedKeysList,
            checkedList:[],
            searchMember:"",
        };
    },
    watch: {
        checkedKeys(val) {
            console.log(val)
            this.checkedList = []
            for(let aa of val){
                let item = this.members.find(it=>it.key == aa)
                if(item!=null){
                    let as = {}
                    as.id = aa 
                    as.name = item.title
                    this.checkedList.push(as) 
                }            
            }
        },

    },
    created(){
        this.getDepartmentGroup()
    },
    methods: {
        async getDepartmentGroup() {
            let rs  = await this.$api.getDepartmentGroup()
            if(rs.err == 0){
                for(let item of rs.data){
                    item.children = []
                    item.key = "C" + item.key  //A1 部门key
                }
                this.treeData = rs.data
            }
            this.getCompanyMembers()
        },
        async getCompanyMembers() {
            let rs  = await this.$api.getCompanyMembers()
            if(rs.err == 0){
                this.members = rs.data
                for(let item of this.treeData){
                    let part = rs.data.filter(it=>it.dep_id == item.id)
                    if(part != null){
                        item.children = part
                    }
                }
            }
        },
        onExpand(expandedKeys) {
            console.log('onExpand', expandedKeys);
            // if not set autoExpandParent to false, if children expanded, parent can not collapse.
            // or, you can remove all expanded children keys.
            this.expandedKeys = expandedKeys;
            this.autoExpandParent = false;
        },
        onCheck(checkedKeys) {
            console.log('onCheck', checkedKeys);
            this.checkedKeys = checkedKeys;
        },
        onSelect(selectedKeys, info) {
            console.log('onSelect', info);
            console.log('selectedKeys', selectedKeys);
            this.selectedKeys = selectedKeys;
        },
        // onSearchMember() {
        //     let rs = await this.$api.getSearchMember(this.searchMember)
        //     if(rs.err == 0){

        //     }
        // },
    },
  };
  </script>
  